import React from "react";
import { Button } from "./Button";

export class Hauptmenue extends React.PureComponent {
    render() {
        const styleTable = { borderCollapse: "collapse", width: "*", height: "*", tableLayout: "fixed" };
        let styleStatus12;
        let styleStatus13;
        if (this.props.alarmNikolaus) {
            styleStatus12 = { color: "transparent" };
            styleStatus13 = { color: "red" };
        }
        let styleStatus22;
        let styleStatus23;
        if (this.props.alarmLothar) {
            styleStatus22 = { color: "transparent" };
            styleStatus23 = { color: "red" };
        }
        return (
            <React.Fragment>
                <br />
                <h1>&nbsp;&nbsp;&nbsp;Feueralarm</h1>
                <br />
                <table style={styleTable}>
                    <tbody>
                        <tr>
                            <td>Nikolausstraße:&nbsp;&nbsp;</td>
                            <td style={styleStatus12}>KEIN&nbsp;</td>
                            <td style={styleStatus13}>ALARM</td>
                        </tr>
                        <tr>
                            <td>Lotharstraße:</td>
                            <td style={styleStatus22}>KEIN&nbsp;</td>
                            <td style={styleStatus23}>ALARM</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <br />
                <Button name={"Meldung"} handleClick={this.props.handleClick} beschriftung={"Meldung"} buttonDisabled={!this.props.alarm} buttonVisible={true} buttonAppearance={true} buttonRot={false} minWidth={200} minHeight={50} margin={6} />
                <br />
                <Button name={"Administration"} handleClick={this.props.handleClick} beschriftung={"Administration"} buttonDisabled={false} buttonVisible={true} buttonAppearance={true} buttonRot={false} minWidth={200} minHeight={50} margin={6} />
            </React.Fragment>
        );
    };
};